module.exports = __webpack_public_path__ + "static/media/trend-portfolio bg3.c424e350.png";